module.exports = __webpack_public_path__ + "static/cupcakes_mobile-5f9da4f4a95df1ebbe33aebeb2d1f06c.png";